export default {
  // 版权信息
  copyright_info: {
    base_info: 'Copyright © 爱福纳（杭州）传动技术有限公司. All Rights Reserved.',
    icp_number: '浙ICP备2025144930号',
    wangAn_beiAn_info: '浙公网安备33010902004042号',
    wangAn_beiAn_number: 33010902004042
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common/locales/zh.js